import styled, { css } from 'styled-components';
import { layout } from 'src/components/base';
import { PriceLabel } from 'src/components/offer/price/price-label';

type ShippingLabelProps = {
  compact?: boolean;
};

export const ShippingLabel = styled(PriceLabel)<ShippingLabelProps>(
  props => css`
    ${props.compact &&
    css`
      font-size: ${layout.measurements.fontSizeSmall};
    `}
  `
);
